import { ref, reactive, toRefs } from 'vue';
import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';;
import axios from 'axios';

const placement = reactive({
  placementDetails: {
    unitPlacementsId: '',
    complexId: '',
    complexName: '',
    placementModels: '',
    sessionId: '',
    unitId: '',
    unitName: '',
    raName: '',
    raId: '',
    ra: '',
    parking: '',
  },
});
const placementIds = reactive({
  sessionId: '',
  complexIds: [],
});
const placements = ref([]);
const currentPlacementSessionId = ref('');
const currentUnitPlacement = ref('');
const unPlacedUsers = ref([]);
const studentNameList = ref([]);
const isShowingColleagueId = ref(false);
const isShowingUsername = ref(false);
const placementOptionsDropDown = ref([]);
const filterModel = ref(null);
const selectedComplexes = ref([]);
const isShowAllRas = ref(false);

export default function usePlacement() {
  const $q = useQuasar();

  const pagination = ref({
    rowsPerPage: 10,
    rowsNumber: -1,
    page: 1,
    sortBy: '',
    descending: false,
  });

  const resetPlacement = () => {
    placement.placementDetails = {};
    placement.placementDetails.complexId = '';
    placement.placementDetails.unitPlacementsId = '';
    placement.placementDetails.complexName = '';
    placement.placementDetails.placementModels = [];
    placement.placementDetails.sessionId = '';
    placement.placementDetails.unitId = '';
    placement.placementDetails.unitName = '';
    placement.placementDetails.raName = '';
    placement.placementDetails.raId = '';
    placement.placementDetails.ra = '';
    placement.placementDetails.parking = '';
  };

  const addPlacements = async (sessionId) => {
    try {
      placementIds.sessionId = sessionId;
      const response = await axios.post(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/placements/`,
        placementIds);
      placements.value = response.data.data;
    } catch (error) {
      console.log(error);
    }
  };

  const prePorcessPlacementOptions = (placementOptions) => {
    const valuesToAdd = [];
    for (let i = 0; i < placementOptions.length; i += 1) {
      switch (placementOptions[i]) {
        case 'First Preference Granted':
          valuesToAdd.push('FirstPreferenceGranted');
          break;
        case 'Second Preference Granted':
          valuesToAdd.push('SecondPreferenceGranted');
          break;
        case 'No Preference Granted':
          valuesToAdd.push('NoPreferenceGranted');
          break;
        case 'DSS':
          valuesToAdd.push('Dss');
          break;
        default:
          break;
      }
    }
    placementOptions = placementOptions.concat(valuesToAdd);// eslint-disable-line no-param-reassign

    return placementOptions;
  };

  const fetchPlacementsByComplexAndRa = async (
    complexId, raId, sessionId, searchFilter,
  ) => {
    try {
      const processedPlacementOptions = prePorcessPlacementOptions(placementOptionsDropDown.value);
      const response = await axios.get(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/placements/fetchPlacementsByComplexAndRa`,
        {
          params: {
            complexId,
            raId,
            sessionId,
            placementOptions: processedPlacementOptions,
            searchFilter,
          },
        });

      return response;
    } catch (error) {
      console.log(error);
    }

    return null;
  };

  const setPlacementsToggleDefault = async () => {
    placements.value.forEach((x) => {
      const temp = x;
      temp.raToggle = false;
    });
    isShowAllRas.value = false;
  };

  const fetchPlacementsBySession = async (
    page = 1, rowsPerPage = 10, descending, sortBy, unitPlacement = null,
  ) => {
    try {
      $q.loading.show();
      const processedPlacementOptions = prePorcessPlacementOptions(
        placementOptionsDropDown.value,
      );
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/Placements`;
      const response = await axios.get(url, {
        params: {
          page,
          rowsPerPage,
          descending,
          sortBy,
          filter: filterModel?.value,
          sessionId: currentPlacementSessionId.value,
          complexFilter: selectedComplexes.value,
          placementOptions: processedPlacementOptions,
        },
      });
      const { data } = response;
      placements.value = data.data;
      pagination.value.rowsNumber = data.rowsNumber;
      await setPlacementsToggleDefault(unitPlacement);
    } catch (error) {
      console.log(error);
    }
    $q.loading.hide();
  };

  const getUnitPlacement = async (sessionId, userId) => {
    try {
      const response = await axios.get(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/placements/getUnitPlacementByUser`,
        {
          params: {
            sessionId,
            userId,
          },
        });
      placement.placementDetails = response.data.data;
      if (placement.placementDetails === null) {
        resetPlacement();
      }
      return response;
    } catch (error) {
      console.log(error);
    }

    return null;
  };

  const getUnPlacedUsers = async (sessionId) => {
    try {
      const response = await axios.get(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/placements/getUnPlacedUsers`,
        {
          params: {
            sessionId,
          },
        });
      unPlacedUsers.value = response.data.data;

      return response;
    } catch (error) {
      console.log(error);
    }

    return null;
  };

  const runAlgo = async (sessionId, applicationIds, unitIds, algorithmOptions) => {
    $q.loading.show();
    let result;
    try {
      const algorithmParameters = {
        sessionId,
        applicationIds,
        unitIds,
        algorithmOptions,
      };
      result = await axios.post(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/placements/runAlgo`,
        algorithmParameters);
    } catch (error) {
      console.log(error);
      result = error.message;
    }
    $q.loading.hide();

    return result;
  };

  const runImportPreviousSession = async (localSessionId) => {
    let result;
    try {
      result = await axios.post(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/placements/runImportPreviousSession`,
        {
          sessionId: localSessionId,
        });
    } catch (error) {
      console.log(error);
      result = error.response;
    }

    return result;
  };

  const runImportPreviousApplications = async (localSessionId) => {
    let result;
    try {
      result = await axios.post(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/placements/runImportPreviousApplications`,
        {
          sessionId: localSessionId,
        });
    } catch (error) {
      console.log(error);
      result = error.response;
    }

    return result;
  };

  const runPlaceAll = async (localSessionId) => {
    $q.loading.show();
    let result;
    try {
      result = await axios.post(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/placements/runPlaceAll`,
        localSessionId);
    } catch (error) {
      console.log(error);
      result = error.message;
    }
    $q.loading.hide();

    return result;
  };

  const updateUnitPlacment = async (localUnitPlacement) => {
    try {
      const result = await axios.put(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/placements/${localUnitPlacement.unitPlacementsId}`,
        localUnitPlacement);

      return result;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  };

  const getAlgorithmUnitResult = async (auditParameters) => {
    try {
      const result = await axios.post(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/placements/algorithmUnitResult`,
        auditParameters);

      return result.data;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  };

  const updatePlacement = async (localPlacement) => {
    try {
      const result = await axios.put(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/placements/updateSinglePlacement`,
        localPlacement);

      return result;
    } catch (error) {
      console.log(error);
    }

    return 400;
  };

  const updateStudentNamelist = async (sessionId) => {
    await getUnPlacedUsers(sessionId);
    studentNameList.value = [];
    for (let i = 0; i < unPlacedUsers?.value?.length; i += 1) {
      studentNameList.value.push({
        value: unPlacedUsers.value[i].userId,
        label: unPlacedUsers.value[i].fullName,
      });
    }
    studentNameList.value = studentNameList.value.filter((v, i, a) => a.indexOf(v) === i);
  };

  return {
    ...toRefs(placement),
    addPlacements,
    currentPlacementSessionId,
    currentUnitPlacement,
    fetchPlacementsByComplexAndRa,
    fetchPlacementsBySession,
    filterModel,
    getUnitPlacement,
    getUnPlacedUsers,
    isShowAllRas,
    isShowingColleagueId,
    isShowingUsername,
    pagination,
    placementOptionsDropDown,
    placements,
    prePorcessPlacementOptions,
    resetPlacement,
    runAlgo,
    runImportPreviousApplications,
    runImportPreviousSession,
    runPlaceAll,
    selectedComplexes,
    studentNameList,
    unPlacedUsers,
    updatePlacement,
    updateStudentNamelist,
    updateUnitPlacment,
    getAlgorithmUnitResult,
  };
}
